import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Navbar from "../components/Navbar";
import expertDefaultImg from "../images/expert-default.png";
import "../styles/mergeExperts.css";
import LoadingIcon from "../images/Loading_icon.gif";
import Swal from "sweetalert2";
import { UrlContext } from "../contexts/UrlContext";

export default function MergeExperts() {
  useEffect(() => {
    document.title = "Merge Experts";
  }, []);
  const { API_URL } = useContext(UrlContext);
  const params = useParams();
  const expertName =
    params.expert_name && params.expert_name !== "undefined"
      ? decodeURIComponent(params.expert_name)
      : "";
  const expert_id =
    params.expert_id && params.expert_id !== "undefined"
      ? params.expert_id
      : "";
  const expert_email =
    params.expert_email && params.expert_email !== "undefined"
      ? decodeURIComponent(params.expert_email)
      : "";
  const [expertsData, setExpertsData] = useState(null);
  const [expertIDList, setExpertIDList] = useState(null);
  const [mergePopup, setMergePopup] = useState(false);
  const mediaLink = "https://media.licdn.com/";
  const databaseLink = "https://images.expertpowerhouse.com";
  const [erxpertObj, setExpertObj] = useState({
    name: expertName,
    email: "",
    profileType: "",
    phoneNumber: "",
    location: "",
    hourlyRateCurrency: "",
    hourlyRate: "",
    dailyRateCurrency: "",
    dailyRate: "",
    availableFrom: "",
    availableComment: "",
    // lastContactedBy: '',
    lastContactedMethod: "",
    lastContactedAt: "",
    // profileCreatedAt: '',
    ephShortProfile: "",
    maxWorkingDays: "",
    // savedBy: '',
    status: "",
    summary: "",
    experience: "",
    expertIDForExperience: "",
    profilePicture: "",
    info: "",
    education: "",
    linkedinProfile: "",
  });

  useEffect(() => {
    const hasIdAndEmail = Boolean(expert_id && expert_email);
    const hasName = Boolean(expertName);

    if (!hasIdAndEmail && !hasName) {
      setExpertsData(null);
      setExpertIDList(null);
      return;
    }

    let isMounted = true;

    const fetchMergeProfiles = async () => {
      const endpoint = hasIdAndEmail
        ? "get-merge-profiles-by-email"
        : "get-merge-profiles";
      const payload = hasIdAndEmail
        ? { expertId: expert_id, expertEmail: expert_email }
        : { expertName };

      try {
        const response = await fetch(`${API_URL}${endpoint}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        });

        const data = await response.json();

        if (!isMounted) return;

        if (data.status === "success" && Array.isArray(data.experts)) {
          const expertList = data.experts.map((expert) => expert.id);
          setExpertsData(data.experts);
          setExpertIDList(expertList);
        } else {
          setExpertsData(null);
          setExpertIDList(null);
        }
      } catch (err) {
        if (!isMounted) return;
        console.log(err);
        setExpertsData(null);
        setExpertIDList(null);
      }
    };

    fetchMergeProfiles();

    return () => {
      isMounted = false;
    };
  }, [API_URL, expertName, expert_id, expert_email]);

  const mergeProfileHandler = () => {
    setMergePopup(true);
    const ephToken = localStorage.getItem("eph-token");
    const token = JSON.parse(ephToken).value;
    const url = `${API_URL}merge-expert-profile`;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({ IDList: expertIDList, expertObj: erxpertObj }),
    })
      .then((res) => res.json())
      .then((data) => {
        setMergePopup(false);
        if (data.status === "success") {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Profile merged successfully!",
            showConfirmButton: false,
            timer: 1500,
          });
          setTimeout(() => {
            window.location.href = "/app/ExpertDetails/" + data.expertID;
          }, 1500);
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: data.text,
            confirmButtonText: "OK",
          });
        }
      })
      .catch((err) => {
        setMergePopup(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Database connection error!",
          confirmButtonText: "OK",
        });
        console.log(err);
      });
  };

  return (
    <>
      <div className="container-div">
        <h1 className="search-con-totalHeading">
          {expertsData?.length
            ? `${expertsData?.length} duplicate profiles are found`
            : `. . . .`}
        </h1>
        <center>
          <span style={{ color: "#365561" }}>
            Please select the information fields that contain updated
            information. <b>Unselected fields will be deleted permanently!</b>
          </span>
        </center>
      </div>

      <div className="container-div" style={{ display: "flex" }}>
        <div className="merge-container-div">
          {expertsData?.map((expert, index) => (
            <div className="topCon-table-row merge-table-row" key={index}>
              <div className="topCon-row-top">
                <ul className="list-unstyled form-inline">
                  <li className="topCon-name-section" style={{ width: "70%" }}>
                    <input
                      type="checkbox"
                      id={`picture${index}`}
                      style={{ marginLeft: "10px" }}
                      onChange={(e) => {
                        const allPictures =
                          document.querySelectorAll(`input[id^='picture']`);
                        allPictures.forEach((picture) => {
                          if (picture.id !== `picture${index}`) {
                            picture.disabled = e.target.checked;
                          }
                        });

                        if (e.target.checked) {
                          setExpertObj((prev) => ({
                            ...prev,
                            profilePicture: expert.profilePicture,
                          }));
                        } else {
                          setExpertObj((prev) => ({
                            ...prev,
                            profilePicture: "",
                          }));
                        }
                      }}
                    />
                    <a
                      href={`/app/ExpertDetails/${expert.id}`}
                      className="topCon-eph-profile"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        className={`topCon-img`}
                        alt=""
                        src={
                          expert?.profilePicture?.includes(mediaLink)
                            ? expert?.profilePicture
                            : `${databaseLink}${expert?.profilePicture}`
                        }
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = expertDefaultImg;
                        }}
                      />
                    </a>
                    <a
                      href={expert.link}
                      className="topCon-name-tag"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {expert.name}
                    </a>
                  </li>
                </ul>
                <div>
                  <table className="merge-profiles-table">
                    <tbody>
                      <tr>
                        <td>
                          <input
                            type="checkbox"
                            id={`email${index}`}
                            onChange={(e) => {
                              const allEmails =
                                document.querySelectorAll(`input[id^='email']`);
                              allEmails.forEach((email) => {
                                if (email.id !== `email${index}`) {
                                  email.disabled = e.target.checked;
                                }
                              });

                              if (e.target.checked) {
                                setExpertObj((prev) => ({
                                  ...prev,
                                  email: expert.email,
                                }));
                              } else {
                                setExpertObj((prev) => ({
                                  ...prev,
                                  email: "",
                                }));
                              }
                            }}
                          />
                          <label htmlFor={`email${index}`}>
                            <b>Email: </b>
                            <span>{expert.email}</span>
                          </label>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <input
                            type="checkbox"
                            id={`profileType${index}`}
                            onChange={(e) => {
                              const allProfileTypes = document.querySelectorAll(
                                `input[id^='profileType']`
                              );
                              allProfileTypes.forEach((profileType) => {
                                if (profileType.id !== `profileType${index}`) {
                                  profileType.disabled = e.target.checked;
                                }
                              });

                              if (e.target.checked) {
                                setExpertObj((prev) => ({
                                  ...prev,
                                  profileType: expert.cons_exp,
                                }));
                              } else {
                                setExpertObj((prev) => ({
                                  ...prev,
                                  profileType: "",
                                }));
                              }
                            }}
                          />
                          <label htmlFor={`profileType${index}`}>
                            <b>Profile type: </b>
                            <span>{expert.cons_exp}</span>
                          </label>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <input
                            type="checkbox"
                            id={`phoneNumber${index}`}
                            onChange={(e) => {
                              const allPhoneNumbers = document.querySelectorAll(
                                `input[id^='phoneNumber']`
                              );
                              allPhoneNumbers.forEach((phoneNumber) => {
                                if (phoneNumber.id !== `phoneNumber${index}`) {
                                  phoneNumber.disabled = e.target.checked;
                                }
                              });

                              if (e.target.checked) {
                                setExpertObj((prev) => ({
                                  ...prev,
                                  phoneNumber: expert.phone_n,
                                }));
                              } else {
                                setExpertObj((prev) => ({
                                  ...prev,
                                  phoneNumber: "",
                                }));
                              }
                            }}
                          />
                          <label htmlFor={`phoneNumber${index}`}>
                            <b>Phone number: </b>
                            <span>{expert.phone_n}</span>
                          </label>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <input
                            type="checkbox"
                            id={`location${index}`}
                            onChange={(e) => {
                              const allLocations = document.querySelectorAll(
                                `input[id^='location']`
                              );
                              allLocations.forEach((location) => {
                                if (location.id !== `location${index}`) {
                                  location.disabled = e.target.checked;
                                }
                              });

                              if (e.target.checked) {
                                setExpertObj((prev) => ({
                                  ...prev,
                                  location: expert.location,
                                }));
                              } else {
                                setExpertObj((prev) => ({
                                  ...prev,
                                  location: "",
                                }));
                              }
                            }}
                          />
                          <label htmlFor={`location${index}`}>
                            <b>Location: </b>
                            <span>{expert.location}</span>
                          </label>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <input
                            type="checkbox"
                            id={`hourlyCurrency${index}`}
                            onChange={(e) => {
                              const allHourlyRatesCurrency = document.querySelectorAll(
                                `input[id^='hourlyCurrency']`
                              );
                              allHourlyRatesCurrency.forEach((hourlyRateCurrency) => {
                                if (hourlyRateCurrency.id !== `hourlyCurrency${index}`) {
                                  hourlyRateCurrency.disabled = e.target.checked;
                                }
                              });

                              if (e.target.checked) {
                                setExpertObj((prev) => ({
                                  ...prev,
                                  hourlyRateCurrency: expert.hourly_rate_currency,
                                }));
                              } else {
                                setExpertObj((prev) => ({
                                  ...prev,
                                  hourlyRateCurrency: "",
                                }));
                              }
                            }}
                          />
                          <label htmlFor={`hourlyCurrency${index}`}>
                            <b>Hourly rate currency: </b>
                            <span>{expert.hourly_rate_currency}</span>
                          </label>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <input
                            type="checkbox"
                            id={`hourlyRate${index}`}
                            onChange={(e) => {
                              const allHourlyRates = document.querySelectorAll(
                                `input[id^='hourlyRate']`
                              );
                              allHourlyRates.forEach((hourlyRate) => {
                                if (hourlyRate.id !== `hourlyRate${index}`) {
                                  hourlyRate.disabled = e.target.checked;
                                }
                              });

                              if (e.target.checked) {
                                setExpertObj((prev) => ({
                                  ...prev,
                                  hourlyRate: expert.hourly_rate,
                                }));
                              } else {
                                setExpertObj((prev) => ({
                                  ...prev,
                                  hourlyRate: "",
                                }));
                              }
                            }}
                          />
                          <label htmlFor={`hourlyRate${index}`}>
                            <b>Hourly rate: </b>
                            <span>{expert.hourly_rate}</span>
                          </label>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <input
                            type="checkbox"
                            id={`dailyCurrency${index}`}
                            onChange={(e) => {
                              const allDailyRatesCurrency = document.querySelectorAll(
                                `input[id^='dailyCurrency']`
                              );
                              allDailyRatesCurrency.forEach((dailyRateCurrency) => {
                                if (dailyRateCurrency.id !== `dailyCurrency${index}`) {
                                  dailyRateCurrency.disabled = e.target.checked;
                                }
                              });

                              if (e.target.checked) {
                                setExpertObj((prev) => ({
                                  ...prev,
                                  dailyRateCurrency: expert.daily_rate_currency,
                                }));
                              } else {
                                setExpertObj((prev) => ({
                                  ...prev,
                                  dailyRateCurrency: "",
                                }));
                              }
                            }}
                          />
                          <label htmlFor={`daily  Currency${index}`}>
                            <b>Daily rate currency: </b>
                            <span>{expert.daily_rate_currency}</span>
                          </label>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <input
                            type="checkbox"
                            id={`dailyRate${index}`}
                            onChange={(e) => {
                              const allDailyRates = document.querySelectorAll(
                                `input[id^='dailyRate']`
                              );
                              allDailyRates.forEach((dailyRate) => {
                                if (dailyRate.id !== `dailyRate${index}`) {
                                  dailyRate.disabled = e.target.checked;
                                }
                              });

                              if (e.target.checked) {
                                setExpertObj((prev) => ({
                                  ...prev,
                                  dailyRate: expert.daily_rate,
                                }));
                              } else {
                                setExpertObj((prev) => ({
                                  ...prev,
                                  dailyRate: "",
                                }));
                              }
                            }}
                          />
                          <label htmlFor={`dailyRate${index}`}>
                            <b>Daily rate: </b>
                            <span>{expert.daily_rate}</span>
                          </label>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <input
                            type="checkbox"
                            id={`availfrom${index}`}
                            onChange={(e) => {
                              const allAvailableFroms =
                                document.querySelectorAll(
                                  `input[id^='availfrom']`
                                );
                              allAvailableFroms.forEach((availableFrom) => {
                                if (availableFrom.id !== `availfrom${index}`) {
                                  availableFrom.disabled = e.target.checked;
                                }
                              });

                              if (e.target.checked) {
                                setExpertObj((prev) => ({
                                  ...prev,
                                  availableFrom: expert.Available_from,
                                }));
                              } else {
                                setExpertObj((prev) => ({
                                  ...prev,
                                  availableFrom: "",
                                }));
                              }
                            }}
                          />
                          <label htmlFor={`availfrom${index}`}>
                            <b>Available from: </b>
                            <span>{expert.Available_from}</span>
                          </label>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <input
                            type="checkbox"
                            id={`availcomment${index}`}
                            onChange={(e) => {
                              const allAvailableComments =
                                document.querySelectorAll(
                                  `input[id^='availcomment']`
                                );
                              allAvailableComments.forEach(
                                (availableComment) => {
                                  if (
                                    availableComment.id !==
                                    `availcomment${index}`
                                  ) {
                                    availableComment.disabled =
                                      e.target.checked;
                                  }
                                }
                              );

                              if (e.target.checked) {
                                setExpertObj((prev) => ({
                                  ...prev,
                                  availableComment: expert.Available_comment,
                                }));
                              } else {
                                setExpertObj((prev) => ({
                                  ...prev,
                                  availableComment: "",
                                }));
                              }
                            }}
                          />
                          <label htmlFor={`availcomment${index}`}>
                            <b>Available comment: </b>
                            <span>{expert.Available_comment}</span>
                          </label>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <input
                            type="checkbox"
                            id={`lastContactedAt${index}`}
                            onChange={(e) => {
                              const allLastContactedAts =
                                document.querySelectorAll(
                                  `input[id^='lastContactedAt']`
                                );
                              allLastContactedAts.forEach((lastContactedAt) => {
                                if (
                                  lastContactedAt.id !==
                                  `lastContactedAt${index}`
                                ) {
                                  lastContactedAt.disabled = e.target.checked;
                                }
                              });

                              if (e.target.checked) {
                                setExpertObj((prev) => ({
                                  ...prev,
                                  lastContactedAt: expert.Date_Created,
                                }));
                              } else {
                                setExpertObj((prev) => ({
                                  ...prev,
                                  lastContactedAt: "",
                                }));
                              }
                            }}
                          />
                          <label htmlFor={`lastContactedAt${index}`}>
                            <b>Last contacted at: </b>
                            <span>{expert.Date_Created}</span>
                          </label>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <input
                            type="checkbox"
                            id={`lastContactedMethod${index}`}
                            onChange={(e) => {
                              const allLastContactedMethods =
                                document.querySelectorAll(
                                  `input[id^='lastContactedMethod']`
                                );
                              allLastContactedMethods.forEach(
                                (lastContactedMethod) => {
                                  if (
                                    lastContactedMethod.id !==
                                    `lastContactedMethod${index}`
                                  ) {
                                    lastContactedMethod.disabled =
                                      e.target.checked;
                                  }
                                }
                              );

                              if (e.target.checked) {
                                setExpertObj((prev) => ({
                                  ...prev,
                                  lastContactedMethod: expert.mail_inmail,
                                }));
                              } else {
                                setExpertObj((prev) => ({
                                  ...prev,
                                  lastContactedMethod: "",
                                }));
                              }
                            }}
                          />
                          <label htmlFor={`lastContactedMethod${index}`}>
                            <b>Last contacted method: </b>
                            <span>{expert.mail_inmail}</span>
                          </label>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <input
                            type="checkbox"
                            id={`ephShortProfile${index}`}
                            onChange={(e) => {
                              const allEphShortProfiles =
                                document.querySelectorAll(
                                  `input[id^='ephShortProfile']`
                                );
                              allEphShortProfiles.forEach((ephShortProfile) => {
                                if (
                                  ephShortProfile.id !==
                                  `ephShortProfile${index}`
                                ) {
                                  ephShortProfile.disabled = e.target.checked;
                                }
                              });

                              if (e.target.checked) {
                                setExpertObj((prev) => ({
                                  ...prev,
                                  ephShortProfile: expert.eph_short,
                                }));
                              } else {
                                setExpertObj((prev) => ({
                                  ...prev,
                                  ephShortProfile: "",
                                }));
                              }
                            }}
                          />
                          <label htmlFor={`ephShortProfile${index}`}>
                            <b>EPH short profile: </b>
                          </label>
                          <textarea readOnly>{expert.eph_short}</textarea>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <input
                            type="checkbox"
                            id={`maxWorkingDays${index}`}
                            onChange={(e) => {
                              const allMaxWorkingDays =
                                document.querySelectorAll(
                                  `input[id^='maxWorkingDays']`
                                );
                              allMaxWorkingDays.forEach((maxWorkingDays) => {
                                if (
                                  maxWorkingDays.id !== `maxWorkingDays${index}`
                                ) {
                                  maxWorkingDays.disabled = e.target.checked;
                                }
                              });

                              if (e.target.checked) {
                                setExpertObj((prev) => ({
                                  ...prev,
                                  maxWorkingDays: expert.max_working_days,
                                }));
                              } else {
                                setExpertObj((prev) => ({
                                  ...prev,
                                  maxWorkingDays: "",
                                }));
                              }
                            }}
                          />
                          <label htmlFor={`maxWorkingDays${index}`}>
                            <b>Max. working days: </b>
                            <span>{expert.max_working_days}</span>
                          </label>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <input
                            type="checkbox"
                            id={`status${index}`}
                            onChange={(e) => {
                              const allStatuses =
                                document.querySelectorAll(
                                  `input[id^='status']`
                                );
                              allStatuses.forEach((status) => {
                                if (status.id !== `status${index}`) {
                                  status.disabled = e.target.checked;
                                }
                              });

                              if (e.target.checked) {
                                setExpertObj((prev) => ({
                                  ...prev,
                                  status: expert.status,
                                }));
                              } else {
                                setExpertObj((prev) => ({
                                  ...prev,
                                  status: "",
                                }));
                              }
                            }}
                          />
                          <label htmlFor={`status${index}`}>
                            <b>Status: </b>
                            <span>{expert.status}</span>
                          </label>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <input
                            type="checkbox"
                            id={`summary${index}`}
                            onChange={(e) => {
                              const allSummaries =
                                document.querySelectorAll(
                                  `input[id^='summary']`
                                );
                              allSummaries.forEach((summary) => {
                                if (summary.id !== `summary${index}`) {
                                  summary.disabled = e.target.checked;
                                }
                              });

                              if (e.target.checked) {
                                setExpertObj((prev) => ({
                                  ...prev,
                                  summary: expert.summ,
                                }));
                              } else {
                                setExpertObj((prev) => ({
                                  ...prev,
                                  summary: "",
                                }));
                              }
                            }}
                          />
                          <label htmlFor={`summary${index}`}>
                            <b>Summary: </b>
                          </label>
                          <textarea readOnly>{expert.summ}</textarea>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <input
                            type="checkbox"
                            id={`experience${index}`}
                            onChange={(e) => {
                              const allExperiences = document.querySelectorAll(
                                `input[id^='experience']`
                              );
                              allExperiences.forEach((experience) => {
                                if (experience.id !== `experience${index}`) {
                                  experience.disabled = e.target.checked;
                                }
                              });

                              if (e.target.checked) {
                                setExpertObj((prev) => ({
                                  ...prev,
                                  experience: expert.experience,
                                  expertIDForExperience: expert.id,
                                }));
                              } else {
                                setExpertObj((prev) => ({
                                  ...prev,
                                  experience: "",
                                  expertIDForExperience: "",
                                }));
                              }
                            }}
                          />
                          <label htmlFor={`experience${index}`}>
                            <b>Experience: </b>
                          </label>
                          <textarea readOnly>{expert.experience}</textarea>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <input
                            type="checkbox"
                            id={`info${index}`}
                            onChange={(e) => {
                              const allInfos =
                                document.querySelectorAll(`input[id^='info']`);
                              allInfos.forEach((info) => {
                                if (info.id !== `info${index}`) {
                                  info.disabled = e.target.checked;
                                }
                              });

                              if (e.target.checked) {
                                setExpertObj((prev) => ({
                                  ...prev,
                                  info: expert.info,
                                }));
                              } else {
                                setExpertObj((prev) => ({
                                  ...prev,
                                  info: "",
                                }));
                              }
                            }}
                          />
                          <label htmlFor={`info${index}`}>
                            <b>Info: </b>
                          </label>
                          <textarea readOnly>{expert.info}</textarea>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <input
                            type="checkbox"
                            id={`education${index}`}
                            onChange={(e) => {
                              const allEducations = document.querySelectorAll(
                                `input[id^='education']`
                              );
                              allEducations.forEach((education) => {
                                if (education.id !== `education${index}`) {
                                  education.disabled = e.target.checked;
                                }
                              });

                              if (e.target.checked) {
                                setExpertObj((prev) => ({
                                  ...prev,
                                  education: expert.education,
                                }));
                              } else {
                                setExpertObj((prev) => ({
                                  ...prev,
                                  education: "",
                                }));
                              }
                            }}
                          />
                          <label htmlFor={`education${index}`}>
                            <b>Education: </b>
                          </label>
                          <textarea readOnly>{expert.education}</textarea>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="topCon-row-bottom">
                <div style={{ margin: "4px 10px 0 10px" }}>
                  <input
                    type="checkbox"
                    id={`link${index}`}
                    onChange={(e) => {
                      const allLinks =
                        document.querySelectorAll(`input[id^='link']`);
                      allLinks.forEach((link) => {
                        if (link.id !== `link${index}`) {
                          link.disabled = e.target.checked;
                        }
                      });

                      if (e.target.checked) {
                        setExpertObj((prev) => ({
                          ...prev,
                          linkedinProfile: expert.link,
                        }));
                      } else {
                        setExpertObj((prev) => ({
                          ...prev,
                          linkedinProfile: "",
                        }));
                      }
                    }}
                  />
                  <label htmlFor={`link${index}`} style={{ cursor: "pointer" }}>
                    <b style={{ marginLeft: "5px" }}>Linkedin Profile: </b>
                  </label>
                  <span>{expert.link}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="tab-pane fade show merge-info-div">
          <h5>Merge Information</h5>
          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                {/* <label className="fontWeight500">Profile picture</label> */}
                <img
                        className={`topCon-img`}
                        alt=""
                        src={
                          erxpertObj?.profilePicture?.includes(mediaLink)
                            ? erxpertObj?.profilePicture
                            : `${databaseLink}${erxpertObj?.profilePicture}`
                        }
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = expertDefaultImg;
                        }}
                      />
              </div>
            </div>
            <div className="col-md-12">
              <div className="form-group">
                <label className="fontWeight500">Email</label>
                <input className="form-control" value={erxpertObj.email} />
              </div>
            </div>
            <div className="col-md-12">
              <div className="form-group">
                <label className="fontWeight500">Profile type</label>
                <input
                  className="form-control"
                  value={erxpertObj.profileType}
                />
              </div>
            </div>
            <div className="col-md-12">
              <div className="form-group">
                <label className="fontWeight500">Phone number</label>
                <input
                  className="form-control"
                  value={erxpertObj.phoneNumber}
                />
              </div>
            </div>
            <div className="col-md-12">
              <div className="form-group">
                <label className="fontWeight500">Location</label>
                <input className="form-control" value={erxpertObj.location} />
              </div>
            </div>
            <div className="col-md-12">
              <div className="form-group">
                <label className="fontWeight500">Hourly rate</label>
                <input className="form-control" value={erxpertObj?.hourlyRateCurrency + " " + erxpertObj.hourlyRate} />
              </div>
            </div>
            <div className="col-md-12">
              <div className="form-group">
                <label className="fontWeight500">Daily rate</label>
                <input className="form-control" value={erxpertObj.dailyRateCurrency +" "+ erxpertObj.dailyRate} />
              </div>
            </div>
            <div className="col-md-12">
              <div className="form-group">
                <label className="fontWeight500">Available from</label>
                <input
                  className="form-control"
                  value={erxpertObj.availableFrom}
                />
              </div>
            </div>
            <div className="col-md-12">
              <div className="form-group">
                <label className="fontWeight500">Available comment</label>
                <input
                  className="form-control"
                  value={erxpertObj.availableComment}
                />
              </div>
            </div>
            <div className="col-md-12">
              <div className="form-group">
                <label className="fontWeight500">Last contacted at</label>
                <input
                  className="form-control"
                  value={erxpertObj.lastContactedAt}
                />
              </div>
            </div>
            <div className="col-md-12">
              <div className="form-group">
                <label className="fontWeight500">Last contacted method</label>
                <input
                  className="form-control"
                  value={erxpertObj.lastContactedMethod}
                />
              </div>
            </div>
            <div className="col-md-12">
              <div className="form-group">
                <label className="fontWeight500">EPH short profile</label>
                <input
                  className="form-control"
                  value={erxpertObj.ephShortProfile}
                />
              </div>
            </div>
            <div className="col-md-12">
              <div className="form-group">
                <label className="fontWeight500">Max. working days</label>
                <input
                  className="form-control"
                  value={erxpertObj.maxWorkingDays}
                />
              </div>
            </div>
            <div className="col-md-12">
              <div className="form-group">
                <label className="fontWeight500">Status</label>
                <input className="form-control" value={erxpertObj.status} />
              </div>
            </div>
            <div className="col-md-12">
              <div className="form-group">
                <label className="fontWeight500">Summary</label>
                <textarea className="form-control" value={erxpertObj.summary} />
              </div>
            </div>
            <div className="col-md-12">
              <div className="form-group">
                <label className="fontWeight500">Experience</label>
                <textarea
                  className="form-control"
                  value={erxpertObj.experience}
                />
              </div>
            </div>
            <div className="col-md-12">
              <div className="form-group">
                <label className="fontWeight500">Info</label>
                <textarea className="form-control" value={erxpertObj.info} />
              </div>
            </div>
            <div className="col-md-12">
              <div className="form-group">
                <label className="fontWeight500">Education</label>
                <textarea
                  className="form-control"
                  value={erxpertObj.education}
                />
              </div>
            </div>
            <div className="col-md-12">
              <div className="form-group">
                <label className="fontWeight500">Linkedin Profile</label>
                <input
                  className="form-control"
                  value={erxpertObj.linkedinProfile}
                />
              </div>
            </div>
          </div>
          <div>
            <center>
              <button
                type="submit"
                className="btn base-btn"
                onClick={mergeProfileHandler}
              >
                Merge
              </button>
            </center>
          </div>
        </div>
      </div>

      {mergePopup && (
        <div className="linkedin-popup-wrapper">
          <div className="tab-pane fade show linkedin-div">
            <center>
              <p style={{ fontSize: "18px" }}>Merging profiles...</p>
              <br />
              <img
                src={LoadingIcon}
                alt=""
                style={{ width: "50px", marginRight: "5px" }}
              />
            </center>
          </div>
        </div>
      )}
    </>
  );
}
